import { z } from "zod";

// "DOCX"/"HTML" are deliberately absent — neither is registered in the backend
// parser_registry, so picking them here would fail every file in the job.
export const PARSER_OPTIONS = [
  { value: "PDF", label: "PDF (Docling)" },
  { value: "PDF_FAST", label: "PDF Fast" },
  { value: "TXT", label: "Text" },
  { value: "MARKDOWN", label: "Markdown" },
] as const;

export const uploadFormSchema = z.object({
  prefix: z.string().optional(),
  schemaId: z.string().nullable(),
  parser: z.string().nullable(),
  withVision: z.boolean(),
  overwrite: z.boolean(),
  deleteCollection: z.boolean(),
  skipIngestion: z.boolean(),
});

export type UploadForm = z.infer<typeof uploadFormSchema>;

export const uploadFormDefaultValues: UploadForm = {
  prefix: undefined,
  schemaId: null,
  parser: null,
  withVision: true,
  overwrite: false,
  deleteCollection: false,
  skipIngestion: false,
};

export type UploadMode = "files" | "folder";

/**
 * Preserve folder structure by renaming files with their relative path.
 * When using folder upload (webkitdirectory), browsers set webkitRelativePath
 * on File objects. We create new File objects with this path as the name
 * so the backend receives the full path for metadata extraction.
 */
export function preserveFilePaths(files: File[]): File[] {
  return files.map((file) => {
    // webkitRelativePath contains the relative path from the selected folder
    // e.g., "folder/subfolder/file.pdf"
    const relativePath = (file as File & { webkitRelativePath?: string }).webkitRelativePath;
    if (relativePath && relativePath !== file.name) {
      // Create a new File with the relative path as the name
      return new File([file], relativePath, { type: file.type, lastModified: file.lastModified });
    }
    return file;
  });
}
